import { useState } from 'react';
import { ArrowRight, LockKey, Moon, Sun, WarningCircle } from '@phosphor-icons/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useColors, useTheme } from '../context/ThemeContext';
import { defaultRouteForUser } from '../lib/pageAccess';

export default function Login() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { theme, toggle } = useTheme();
  const C = useColors();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async event => {
    event.preventDefault();
    if (!password || loading) return;
    setError('');
    setLoading(true);
    try {
      const data = await login(password);
      const from = typeof location.state?.from === 'string' && location.state.from.startsWith('/') && !location.state.from.startsWith('//') ? location.state.from : null;
      navigate(from || defaultRouteForUser(data), { replace: true });
    } catch {
      setError('That access code is not recognized.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-screen" style={{ background: C.bg, color: C.text1 }}>
      <button className="login-theme" onClick={toggle} aria-label={theme === 'dark' ? 'Use light theme' : 'Use dark theme'}>
        {theme === 'dark' ? <Sun size={17} /> : <Moon size={17} />}
      </button>

      <section className="login-panel" style={{ background: C.s1, borderColor: C.border }}>
        <header className="login-brand">
          <div><strong>CUZO</strong><span>In-house</span></div>
          <LockKey size={21} />
        </header>

        <div className="login-copy">
          <h1>Sign in</h1>
          <p>Use your agency access code to open the operations workspace.</p>
        </div>

        <form onSubmit={handleSubmit}>
          <label htmlFor="access-code">Access code</label>
          <input
            id="access-code"
            type="password"
            value={password}
            onChange={event => { setPassword(event.target.value); setError(''); }}
            placeholder="Enter your access code"
            autoComplete="current-password"
            autoFocus
            aria-invalid={Boolean(error)}
            aria-describedby={error ? 'login-error' : undefined}
          />
          {error && <div className="login-error" id="login-error"><WarningCircle size={16} />{error}</div>}
          <button className="login-submit" type="submit" disabled={loading || !password}>
            <span>{loading ? 'Verifying…' : 'Continue'}</span>
            {!loading && <ArrowRight size={17} />}
          </button>
        </form>

        <footer>Restricted to authorized CUZO team members.</footer>
      </section>
    </main>
  );
}
